import { Validation } from './Validation';

export default interface HolidayProgramPriceJson {
   /**
    * Name des Preises, ist leer für den Basispreis.
    */
   title: string;

   /**
    * Besondere Hinweise die für diesen Preis oder diese Vergünstigung gelten. Kann ein leerer String sein wenn nichts besonderes gilt.
    */
   remarks: string;

   /**
    * Preis zu dem dieses Programm angeboten wird in Eurocent. Gilt für das erste Kind.
    */
   priceFirstChild: number,

   /**
    * Preis zu dem dieses Programm angeboten wird in Eurocent. Gilt für alle weiteren Kinder.
    */
   priceAdditionalChild: number,

   /**
    * Stornierungsgebuer in Eurocent.
    */
   cancellationFee: number,

   /**
    * Stornierungsbedingungen.
    */
   cancellationRemarks: string,

   /**
    * Gibt für das Kunden-Buchungsformular an, in welche Klasse die Kinder für das Programm mindestens gehen müssen. Kann null sein, falls keine Einschränkung besteht.
    */
   childrenClassMinimum: number | null;

   /**
    * Gibt für das Kunden-Buchungsformular an, in welche Klasse die Kinder für das Programm maximal gehen dürfen. Kann null sein, falls keine Einschränkung besteht.
    */
   childrenClassMaximum: number | null;

   /**
    * Gibt an, dass dieser Tarif nur verfügbar ist, wenn alle Erziehnungsberechtigten berufstätig sind.
    * Kann undefined sein für alte Datenbankeinträge, wird in dem Fall wie false behandelt.
    */
   requiresAllGuardiansEmployed?: boolean;

   /**
    * Gibt an, dass für diesen Tarif selectedDiscountInfo als Pflichtfeld ausgefüllt werden muss.
    */
   requiresSelectedDiscountInfo?: boolean;

   /**
    * Gibt an, ob bei diesem Tarif die Arbeitgeber abgefragt werden sollen.
    */
   showEmployerInputs?: boolean;

   /**
    * Gibt an, dass die Angabe der Arbeitgeber verpflichtend ist.
    */
   requiresEmployerInputs?: boolean;
}

export function defaultHolidayProgramPriceJson() {
   return {
      title: "",
      remarks: "",
      priceFirstChild: 0,
      priceAdditionalChild: 0,
      cancellationFee: 0,
      cancellationRemarks: "",
      childrenClassMinimum: null,
      childrenClassMaximum: null,
      requiresAllGuardiansEmployed: false,
      requiresSelectedDiscountInfo: false,
      showEmployerInputs: false,
      requiresEmployerInputs: false,
   };
}

export function validateHolidayProgramPriceJson(item: HolidayProgramPriceJson) {
   return new Validation(item)
      .validateNonEmptyString("title", 100)
      .validateString("remarks", 500)
      .validateInteger("priceFirstChild", 0)
      .validateInteger("priceAdditionalChild", 0)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .validateInteger("childrenClassMinimum", 0, 120, true)
      .validateInteger("childrenClassMaximum", 0, 120, true)
      .finish();
}